import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import { StyleTableFooterCell } from './styles';
import { type TableFooterCellProps } from './types';
export const TableFooterCell = forwardRef<HTMLTableCellElement, TableFooterCellProps>((t0, ref) => {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props || $[5] !== ref) {
    t1 = <StyleTableFooterCell ref={ref} {...props}>{children}</StyleTableFooterCell>;
    $[3] = children;
    $[4] = props;
    $[5] = ref;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
});
export default TableFooterCell;